document.addEventListener("DOMContentLoaded", () => {
  if (BSS_B2B) {
    setTimeout(() => {
      BSS_B2B.observer.cartSubject.notifyObserver(
        "CartMutate",
        "CartPriceMutate"
      );
    }, 2000);
    document
      .querySelector('form[action="/cart/add"] button[name="add"]')
      .addEventListener("click", (e) => {
        setTimeout(() => {
          const jobId = setInterval(() => {
            if (document.querySelector("cart-item-original-line-price")) {
              if (document.querySelector("cart-item-original-line-price .money")) {
                for (const [key, item] of BSS_B2B.storage.cartStorage.getAll()) {
                  const cartItemEle = document.querySelector(`cart-item[key='${key}']`);
                  const target = cartItemEle.querySelector('[bss-b2b-final-line-price][bss-b2b-cart-item-key]');
                  target.setAttribute("bss-b2b-cart-item-key", key);
                }
              }
              BSS_B2B.observer.cartSubject.miniCart.handleMiniCartOpen();
              BSS_B2B.observer.cartSubject.notifyObserver(
                "CartPriceMutate",
                "ClickOpenMiniCart",
                {
                  event: {
                    isTrusted: true,
                  },
                }
              );
            }
            clearInterval(jobId);
          }, 500);
          setTimeout(() => {
            clearInterval(jobId);
          }, 5000);
        }, 4000);
      });
  }
});
